import { render, staticRenderFns } from "./GZipForm.vue?vue&type=template&id=2bffb8f6&"
import script from "./GZipForm.vue?vue&type=script&lang=ts&"
export * from "./GZipForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports